import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createInsightFeedEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackInsightFeedOpen = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.INSIGHT_FEED_OPEN,
      properties: { source },
    });

  const trackInsightFeedTabSelected = (
    source: PosthogTrackingSource,
    type: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.INSIGHT_FEED_TAB_SELECTED,
      properties: { source, type },
    });

  const trackInsightFeedFilterSelected = (
    source: PosthogTrackingSource,
    type: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.INSIGHT_FEED_FILTER_SELECTED,
      properties: { source, type },
    });

  const trackDashboardWhatsNewTabSelected = (
    source: PosthogTrackingSource,
    type: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.DASHBOARD_WHATS_NEW_TAB_SELECTED,
      properties: { source, type },
    });

  const trackMarketSummaryOpen = (
    source: PosthogTrackingSource,
    type: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.MARKET_SUMMARY_OPEN,
      properties: { source, type },
    });

  return {
    trackInsightFeedOpen,
    trackInsightFeedTabSelected,
    trackInsightFeedFilterSelected,
    trackDashboardWhatsNewTabSelected,
    trackMarketSummaryOpen,
  };
};
